class Coupon {
	addOns = [];
	durationInMonths = 0;
	durationLabel = '';
	id = '';
	plan = '';
	tierName = '';
	planTier = '';
	product = '';
	isScope = false;
	isDrive = false;
	type = '';
	isMaintenance = false;
	planWithContext = '';
	maintenanceEnds = null;

	calculateMaintenanceExpiry(durationInMonths, maintenanceEnds) {
		if (!maintenanceEnds) {
			return;
		}
		const expiry = new Date(maintenanceEnds);
		this.maintenanceEnds =  new Date(expiry.setMonth(expiry.getMonth()+durationInMonths));
	};
}

export default Coupon;



// WEBPACK FOOTER //
// ./src/store/models/coupon.js